import Dashboard from './Dashboard.vue'
import HomeLayout from '@/layouts/Home.vue'

export const dashboardRoutes = [
  {
    path: '/home',
    name: 'inicio',
    component: Dashboard,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: [
        'admin',
        'superadmin',
        'supervisor',
        'employee',
        'admin users & supervisors',
        'RRHH',
      ],
    },
  },
]
